// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var OrganizationID = function (x) {
    return x;
};
var tsBridgeOrganizationID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationID")("__brandOrganizationID"));
    }
};
var writeOrganizationID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showOrganizationID = Data_Show.showString;
var readOrganizationID = Simple_JSON.readString;
var ordOrganizationID = Data_Ord.ordString;
var newtypeOrganizationID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeOrganizationID = OrganizationID;
var eqOrganizationID = Data_Eq.eqString;
export {
    OrganizationID,
    makeOrganizationID,
    unwrap,
    newtypeOrganizationID,
    eqOrganizationID,
    ordOrganizationID,
    showOrganizationID,
    readOrganizationID,
    writeOrganizationID,
    tsBridgeOrganizationID
};
//# sourceMappingURL=index.js.map
